import InlineSvg from "vue-inline-svg";

export default {
  props: {
    name: {
      type: String,
    },
  },
  components: {
    InlineSvg,
  },
};
